import React from 'react'

class Hero extends React.Component {
	render() {
		return (
			<div className="rf-hero">
				<div className="container">
					<div className="heading">
						<h2 className="title">{ this.props.heading }</h2>
					</div>
				</div>
			</div>
		)
	}
}

export default Hero


// WEBPACK FOOTER //
// ./src/components/Reset/Hero.js